import { Config } from "@forgerock/javascript-sdk"
import {
	SERVER_URL,
	WEB_OAUTH_CLIENT,
	SCOPE,
	JOURNEY_LOGIN,
	REALM_PATH,
	CENTRALIZED_LOGIN
} from "@utils/constants.util"

export const initializeForgeRock = async (): Promise<void> => {
	try {
		const urlParams = new URLSearchParams(window.location.search)
		const journeyParam = urlParams.get("journey")
		const centralLoginParam = urlParams.get("centralLogin")

		const config = {
			clientId: WEB_OAUTH_CLIENT,
			redirectUri: `${window.location.origin}/${
				CENTRALIZED_LOGIN === "true" || centralLoginParam === "true"
					? "login?centralLogin=true"
					: "oauth/callback"
			}`,
			serverConfig: {
				baseUrl: SERVER_URL,
				timeout: 3000
			},
			scope: SCOPE,
			realmPath: REALM_PATH,
			tree: `${journeyParam || JOURNEY_LOGIN}`
		}

		Config.set(config)
	} catch (error) {
		console.error("Failed to initialize ForgeRock SDK:", error)
		throw error
	}
}
